"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserCheck = void 0;
var tslib_1 = require("tslib");
var detect_browser_1 = require("detect-browser");
var js_cookie_1 = tslib_1.__importDefault(require("js-cookie"));
var modal_service_1 = require("../components/modal/modal.service");
var i18n_1 = require("../i18n");
var mithril_1 = require("../mithril");
var compatibleBrowsers = ['edge', 'edge-ios', 'edge-chromium', 'chrome', 'chromium-webview', 'firefox'];
var incompatibleOS = ['iOS', 'Android OS', 'BlackBerry OS', 'Windows Mobile'];
var USE_INCOMPATIBLE_BROWSER_OS = 'useIncompatibleBrowserOS';
var EXPIRY_COOKIE_DAYS = 1;
var BrowserCheck = /** @class */ (function () {
    function BrowserCheck() {
        this.browser = (0, detect_browser_1.browserName)(navigator.userAgent);
        this.os = (0, detect_browser_1.detectOS)(navigator.userAgent);
    }
    BrowserCheck.prototype.validateBrowser = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var dismissedMessageCookie, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dismissedMessageCookie = js_cookie_1.default.get(USE_INCOMPATIBLE_BROWSER_OS);
                        if (dismissedMessageCookie) {
                            return [2 /*return*/];
                        }
                        result = { ok: false, cancel: false };
                        if (!incompatibleOS.includes(this.os)) return [3 /*break*/, 2];
                        return [4 /*yield*/, modal_service_1.ModalService.open({
                                title: i18n_1.T.MESSAGE_MOBILE_VALIDATION_TITLE,
                                content: (0, i18n_1.Translate)(i18n_1.T.MESSAGE_MOBILE_VALIDATION_CONTENT),
                                hasCancel: false,
                                canClose: function () { return true; }
                            })];
                    case 1:
                        result = _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        if (!!compatibleBrowsers.includes(this.browser)) return [3 /*break*/, 4];
                        return [4 /*yield*/, modal_service_1.ModalService.open({
                                title: i18n_1.T.MESSAGE_BROWSER_VALIDATION_TITLE,
                                content: function () { return (0, mithril_1.m)('div', [
                                    (0, mithril_1.m)('span', (0, i18n_1.Translate)(i18n_1.T.MESSAGE_BROWSER_VALIDATION_CONTENT)),
                                    (0, mithril_1.m)('a', { href: (0, i18n_1.Translate)(i18n_1.T.MESSAGE_BROWSER_VALIDATION_URL), target: '_blank' }, (0, i18n_1.Translate)(i18n_1.T.MESSAGE_BROWSER_VALIDATION_URL_TEXT))
                                ]); },
                                hasCancel: false,
                                canClose: function () { return true; }
                            })];
                    case 3:
                        result = _a.sent();
                        _a.label = 4;
                    case 4:
                        if (result.ok) {
                            js_cookie_1.default.set(USE_INCOMPATIBLE_BROWSER_OS, '1', { expires: EXPIRY_COOKIE_DAYS });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return BrowserCheck;
}());
exports.BrowserCheck = BrowserCheck;
//# sourceMappingURL=browser-check.js.map